import React from "react";
import { Stack, Typography } from "@mui/material";
import Balancer from "react-wrap-balancer";

import { Card } from "./card";
import { WovoLogo } from "./wovo-logo";

export function LogoHeaderCard({
  title,
  subtitle,
  loading,
  maxWidth,
  hideHeader,
  children,
  logoSize = 64,
  noBorder = false,
}) {
  return (
    <Card
      sx={{
        width: "100%",
        height: "auto",
        padding: 6,
        maxWidth,
        ...(noBorder ? undefined : { border: 1, borderColor: "divider" }),
      }}
      loading={loading}
      elevation={0}
    >
      <Stack gap={4}>
        {!hideHeader && (
          <Stack component="header" sx={{ alignItems: "center" }} gap={2}>
            <WovoLogo size={logoSize} />
            {(title || subtitle) && (
              <Stack gap={1}>
                {title && (
                  <Typography
                    variant="h6"
                    sx={{ textAlign: "center", fontWeight: 600 }}
                  >
                    {title}
                  </Typography>
                )}
                {subtitle && (
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", textAlign: "center" }}
                  >
                    <Balancer>{subtitle}</Balancer>
                  </Typography>
                )}
              </Stack>
            )}
          </Stack>
        )}
        {children}
      </Stack>
    </Card>
  );
}
